import OnboardingEmail from 'vcomponents/pages/onboarding/email/OnboardingEmail.vue';
import OnboardingEmailFinal from 'vcomponents/pages/onboarding/email/OnboardingEmailFinal.vue';
import OnboardingEmailSyncOffice365 from 'vcomponents/pages/onboarding/email/sync/OnboardingEmailSyncOffice365.vue';

import OnboardingQuicktrial from 'vcomponents/pages/onboarding/trial/OnboardingQuicktrial.vue';
import OnboardingQuicktrialSignup from 'vcomponents/pages/onboarding/trial/OnboardingQuicktrialSignup.vue';
import OnboardingQuicktrialGoogle from 'vcomponents/pages/onboarding/trial/OnboardingQuicktrialGoogle.vue';
import OnboardingQuickTrialFinal from 'vcomponents/pages/onboarding/trial/OnboardingQuickTrialFinal.vue';
import OnboardingQuicktrialMobile from 'vcomponents/pages/onboarding/trial/OnboardingQuicktrialMobile.vue';

import OnboardingScreen from 'vcomponents/pages/onboarding/screen/OnboardingScreenFullWidth.vue';

export default [
    {
        path: '/onboarding/email',
        name: 'onboarding.email',
        component: OnboardingEmail,
        meta: { previousRoute: null },
        props: true,
    },
    {
        path: '/onboarding/email/final',
        name: 'onboarding.email.final',
        component: OnboardingEmailFinal,
        props: true,
    },
    {
        path: '/onboarding/email/sync/office365',
        name: 'onboarding.email.sync.office365',
        component: OnboardingEmailSyncOffice365,
        props: true,
    },
    {
        path: '/onboarding/staff/systemfields/segment',
        name: 'legacy.onboarding.systemfields.activities',
    },
    {
        path: '/onboarding/staff/systemfields/employees',
        name: 'legacy.onboarding.systemfields.employees',
    },
    {
        path: '/rest/staffs/:staffid/systemfields',
        name: 'legacy.onboarding.systemfields.update',
    },
    {
        path: '/onboarding/quicktrial',
        name: 'onboarding.quicktrial',
        component: OnboardingQuicktrial,
        children: [
            {
                path: '',
                name: 'onboarding.quicktrial.signup',
                component: OnboardingQuicktrialSignup,
            },
            {
                path: 'google',
                name: 'onboarding.quicktrial.google',
                component: OnboardingQuicktrialGoogle,
            },
        ],
    },
    {
        path: '/onboarding/quicktrial/final',
        name: 'onboarding.quicktrial.final',
        component: OnboardingQuickTrialFinal,
        props: true,
    },
    {
        path: '/onboarding-screen',
        name: 'onboarding.onboarding_screen',
        component: OnboardingScreen,
    },
    {
        path: '/onboarding-trial-mobile',
        name: 'onboarding.trial_mobile',
        component: OnboardingQuicktrialMobile,
    },
];
